import { render, staticRenderFns } from "./LegalDocumentFormFilesEscalated.vue?vue&type=template&id=a21cbf60&scoped=true&"
import script from "./LegalDocumentFormFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentFormFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentFormFilesEscalated.vue?vue&type=style&index=0&id=a21cbf60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21cbf60",
  null
  
)

export default component.exports